import {
  getSupabaseBrowserClient,
  IS_SUPABASE_CONFIGURED,
} from "../../../common/network/SupabaseClient";
import { readRuntimeConfigValue } from "../../../common/runtimeConfig";
import type { ClinicOnboardingPayload } from "../types";

export const CLINIC_ONBOARDING_SUPABASE_TABLE = String(
  readRuntimeConfigValue("REACT_APP_SUPABASE_CLINIC_ONBOARDING_TABLE") ||
    process.env.REACT_APP_SUPABASE_CLINIC_ONBOARDING_TABLE ||
    "clinic_onboarding_submissions"
).trim();

type ClinicOnboardingSubmissionRow = {
  schema_version: ClinicOnboardingPayload["schemaVersion"];
  submitted_at: string;
  source: string;
  clinic_name: string;
  clinic_email: string;
  point_of_contact_name: string;
  point_of_contact_email: string;
  point_of_contact_phone: string;
  point_of_contact_phone_digits: string;
  location_count: number;
  locations: ClinicOnboardingPayload["locations"];
  payload: ClinicOnboardingPayload;
};

export const saveClinicOnboardingSubmission = async (
  payload: ClinicOnboardingPayload
) => {
  if (!IS_SUPABASE_CONFIGURED) {
    throw new Error(
      "Supabase environment variables are not configured for this app."
    );
  }

  const supabase = getSupabaseBrowserClient();
  if (!supabase) {
    throw new Error("Supabase client could not be initialized.");
  }

  if (!payload.locations.length) {
    throw new Error("At least one clinic location is required.");
  }

  const submissionRow: ClinicOnboardingSubmissionRow = {
    schema_version: payload.schemaVersion,
    submitted_at: payload.submittedAt,
    source: payload.source,
    clinic_name: payload.clinic.name,
    clinic_email: payload.clinic.email,
    point_of_contact_name: payload.pointOfContact.name,
    point_of_contact_email: payload.pointOfContact.email,
    point_of_contact_phone: payload.pointOfContact.phoneNumber,
    point_of_contact_phone_digits: payload.pointOfContact.phoneDigits,
    location_count: payload.metadata.locationCount,
    locations: payload.locations,
    payload,
  };

  const { error } = await supabase
    .from(CLINIC_ONBOARDING_SUPABASE_TABLE)
    .insert(submissionRow);

  if (error) {
    throw new Error(error.message);
  }
};
